'use client';

import { useEffect } from 'react';
import useThemeStore from '@/store/useThemeStore';

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { colors } = useThemeStore();

  useEffect(() => {
    // 动态设置 body 的背景色
    document.body.style.backgroundColor = colors.homeBgColor;
  }, [colors.homeBgColor]);

  return <>{children}</>;
}